var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion",class:{open: _vm.open}},[_c('div',{staticClass:"button",on:{"click":_vm.toggle}},[_vm._t("button"),_c('fa',{staticClass:"chevron",attrs:{"icon":"chevron-down"}})],2),_c('div',{staticClass:"content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }